import React from 'react';
import Icon from '../../../components/AppIcon';
import CompanyTableRow from './CompanyTableRow';

/**
 * Desktop table view for displaying companies with sorting
 */
const CompanyTable = ({ 
  companies, 
  sortConfig, 
  onSort, 
  onToggleStatus, 
  onDelete 
}) => {
  return (
    <div className="hidden lg:block overflow-x-auto">
      <table className="w-full">
        <thead className="bg-gray-50 border-b border-border">
          <tr>
            <th
              className="px-4 py-3 text-left text-xs font-medium text-text-secondary uppercase tracking-wider cursor-pointer select-none"
              onClick={() => onSort('name')}
            >
              <div className="flex items-center gap-2">
                Company
                {sortConfig?.key === 'name' && (
                  <Icon
                    name={sortConfig?.direction === 'asc' ? 'ChevronUp' : 'ChevronDown'}
                    size={14}
                  />
                )}
              </div>
            </th>
            <th
              className="px-4 py-3 text-left text-xs font-medium text-text-secondary uppercase tracking-wider cursor-pointer select-none"
              onClick={() => onSort('status')}
            >
              <div className="flex items-center gap-2">
                Status
                {sortConfig?.key === 'status' && (
                  <Icon
                    name={sortConfig?.direction === 'asc' ? 'ChevronUp' : 'ChevronDown'}
                    size={14}
                  />
                )}
              </div>
            </th>
            <th
              className="px-4 py-3 text-left text-xs font-medium text-text-secondary uppercase tracking-wider cursor-pointer select-none"
              onClick={() => onSort('createdAt')}
            >
              <div className="flex items-center gap-2">
                Dates
                {sortConfig?.key === 'createdAt' && (
                  <Icon
                    name={sortConfig?.direction === 'asc' ? 'ChevronUp' : 'ChevronDown'}
                    size={14}
                  />
                )}
              </div>
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-text-secondary uppercase tracking-wider">
              Quick Links
            </th>
            <th className="px-4 py-3 text-left text-xs font-medium text-text-secondary uppercase tracking-wider">
              Actions
            </th>
          </tr>
        </thead>
        <tbody className="divide-y divide-border">
          {companies?.length > 0 ? (
            companies?.map((company) => (
              <CompanyTableRow
                key={company?.id}
                company={company}
                onToggleStatus={onToggleStatus}
                onStatusToggle={onToggleStatus}
                onDelete={onDelete}
                onDuplicate={() => {}}
              />
            ))
          ) : (
            <tr>
              <td colSpan="5" className="px-6 py-12 text-center text-text-secondary">
                No companies found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default CompanyTable;